<template>
  <div id="succes-message">
    <div class="icon">👍</div>
  </div>
</template>

<script>
  import { gsap } from "gsap";
  import EventBus from "../eventBus";

  export default {
    name: "Notification",
    components: {},
    props: {
      msg: String,
    },
    mounted() {
      EventBus.$on("tokenSucces", this.showSuccesMessage);
    },
    methods: {
      // show message when token is placed on the correct position
      showSuccesMessage: function () {
        gsap.fromTo(
          this.$el,
          {
            duration: 1,
            opacity: 0,
            rotation: -7,
          },
          {
            rotation: 0,
            opacity: 1,
            ease: "quint.easeOut",
            force3D: true,
            onComplete: () => this.showSuccesMessageComplete(),
          }
        );
      },
      showSuccesMessageComplete: function () {
        gsap.to(this.$el, {
          duration: 0.5,
          opacity: 0,
        });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #succes-message {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    pointer-events: none;
    font-size: 162px;
    margin-left: 3.5vw;
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
    transform-origin: left bottom;
    opacity: 0;
  }
</style>
